import React, { useState, useEffect } from 'react';
import Myorder from './Myorder';
import Footer from '../Footer/Footer';
import Navbar from '../Navbar/Navbar';
import useAuth from '../hooks/useAuth';
import { getWindowDimensions } from '../../driver';
import { useGetMyorderQuery } from '../../features/api/apiSlice';
const MyorderPage = () => {
    const [orders, setOrders] = useState([]);
    const { user } = useAuth();
    const { data: myOrders, isLoading, isError } = useGetMyorderQuery(user?.email);


    const [windowDimensions, setWindowDimensions] = useState(getWindowDimensions());
    useEffect(() => {
        function handleResize() {
            setWindowDimensions(getWindowDimensions());
        }

        window.addEventListener('resize', handleResize);
        return () => window.removeEventListener('resize', handleResize);
    }, [])

    useEffect(() => {
        setOrders(myOrders ? myOrders[0] : [])
    }, [myOrders]);

    let content = null;

    if (isLoading) content = <div className="loading">Loading&#8230;</div>;
    if (!isLoading && isError) content = "Something is wrong!"

    if (!isLoading && !isError && myOrders.length > 0) {
        content = <>
            <Navbar />
            <Myorder
                orders={orders}
                windowDimensions={windowDimensions}
            />
            <Footer />
        </>
    }
    return (
        content
    );
};

export default MyorderPage;